import { version } from './version';

export const environment = {
  production: true,
  integration: false,
  ...version,
};
